import $ from 'jquery';
import bootbox from 'bootbox';

$(() => {
    $(document).on("click", ".activate-searchtext-modal", (e) => {
        let $elem = $(e.target);
        bootbox.alert({
            title: "Søgetekst: " + $elem.data('jobtitle'),
            message: $elem.data('searchtext'),
            backdrop: true
        });
    });

    $(document).on("click", ".humanjob_correction_button", (e) => {
        let $elem = $(e.target);
        e.preventDefault();
        bootbox.confirm("Er du sikker på at du vil tilføje en rettelse?", function(result) {
            if (result === true) {
                $elem.closest('form').trigger('submit');
            }
        });
    });
});
